module.exports = __webpack_public_path__ + "img/beamylogo_white.cf396be2.svg";